export const getTags = 'tags/';

/**Urls para Red-I API */
export const getToken = 'token/';
export const usuarios = 'usuarios/';
export const getRoles = usuarios + 'getRoles/';
export const cambiarRol = usuarios + 'cambiarRol/';
/**Urls sobre instituciones */
export const instituciones = 'instituciones/';
export const getInstitucionLanding = instituciones + 'landing/';
export const getInstitucionStaff = instituciones + 'landingStaff/';
export const getInstitucionUnidad = instituciones + 'landingUnidades/';
/**Urls para posts */
export const posts = `posts`
export const getCategorias = `${posts}/categorias`;
export const verPost = `${posts}/ver/`;
/**Urls para tags */
export const tagsInstitucionales = 'institucionales';


/**Urls perfit para suscripciones MO */
export const subscribeUserMO = '/maggieokon/contacts';

/**Urls integraciones terceros */
export const crmIntegrations = 'landings-crm-integrations/';
export const getIntegrations = 'integration/'; 
